"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceTariffRoundupStrategy = void 0;
var VoiceTariffRoundupStrategy;
(function (VoiceTariffRoundupStrategy) {
    VoiceTariffRoundupStrategy["NoRoundup"] = "NoRoundup";
    VoiceTariffRoundupStrategy["CeilNearest10Seconds"] = "CeilNearest10Seconds";
    VoiceTariffRoundupStrategy["CeilNearest30Seconds"] = "CeilNearest30Seconds";
    VoiceTariffRoundupStrategy["CeilNearest60Seconds"] = "CeilNearest60Seconds";
    VoiceTariffRoundupStrategy["Ceil15To60"] = "Ceil15To60";
})(VoiceTariffRoundupStrategy = exports.VoiceTariffRoundupStrategy || (exports.VoiceTariffRoundupStrategy = {}));
